// Pricing — the Pro card's figure.
//
// It is the product of two controls: the seat picker above the cards (1..6
// handsets) multiplies whichever base the Pro card's billing cycle selects. Both are
// radio groups whose painted state is pure CSS, and the markup ships the pair the
// model read back out of session already rendered ($20.00 for the default, one
// handset, monthly), so the card is correct before this file loads; all it does is
// keep the figure in step once one of them changes.
//
// The two bases live on the cycle radios as data-price rather than here, so the
// number in the markup and the number this multiplies cannot drift apart.
import { debounce } from 'lodash-es';
import { mountLottieMarks } from '../Assets/lottieMark';

const amount = document.querySelector<HTMLElement>('.pr-plans .tier.featured .price .amount');
const seats = [...document.querySelectorAll<HTMLInputElement>('input[name="seats"]')];
const cycles = [...document.querySelectorAll<HTMLInputElement>('input[name="cycle"]')];

if (amount && seats.length && cycles.length) {
    const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    const render = (): void => {
        const cycle = cycles.find((radio) => radio.checked);
        const seat = seats.find((radio) => radio.checked);
        if (!cycle || !seat) {
            return;
        }

        amount.textContent = usd.format(Number(cycle.dataset.price) * Number(seat.value));
    };

    for (const radio of [...seats, ...cycles]) {
        radio.addEventListener('change', render);
    }

    // Once on load as well: a reload or a back-navigation has the browser restore the
    // radios' last state, which the server-rendered figure knows nothing about.
    render();

    // The row drops seats from the end as the window narrows, and a display:none label
    // leaves its input checked — so a selection can go into hiding and the figure would
    // keep counting a seat the picker no longer shows. Fall back to the last one still
    // on screen. Only narrowing can do this; widening just reveals more.
    const onScreen = (radio: HTMLInputElement): boolean =>
        (radio.closest('.seat')?.getClientRects().length ?? 0) > 0;

    window.addEventListener('resize', debounce(() => {
        const seat = seats.find((radio) => radio.checked);
        if (!seat || onScreen(seat)) {
            return;
        }

        const visible = seats.filter(onScreen);
        const last = visible[visible.length - 1];
        if (last) {
            last.checked = true;
            render();
        }
    }, 150));
}

// The price-tag mark beside the savings line.
mountLottieMarks();
